import React from "react";
import Image from "next/image";

const BannerDesktopHFM = () => {
  return (
    <div className="mx-auto square_grid_bg w-full xl:h-[580px] lg:h-[450px] xl:px-0 md:px-6 lg:!px-6 relative px-0">
      <div className="lg:container 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] relative md:block hidden">
        <div className="flex justify-between flex-wrap">
          <div className="md:pt-5 pt-5 pb-7 2xl:w-[66%] xl:w-[64%] lg:w-[64%] md:w-[64%] w-full md:pb-16 relative md:top-[135px]">
            <div className="md:text-left text-left">
              <h1 className="2xl:text-[50px] xl:text-[50px] md:leading-[54px] md:text-[38px] text-[50px] font-bold text-black inline-block relative">
                <span>Connecting Organizations</span>
                <Image
                  priority
                  src="/hire-from-miles/star1.svg"
                  alt="star"
                  className="absolute -top-3 -left-4"
                  width={22}
                  height={20}
                  quality={100}
                />
              </h1>
              <p className="text-black 2xl:text-[50px] xl:text-[50px] md:leading-[54px] md:text-[38px]  text-[50px] font-bold md:mt-2 relative">
                With The Best Talent
                <br /> Across{" "}
                <Image
                  priority
                  src="/hire-from-miles/star2.svg"
                  alt="star"
                  className="absolute bottom-6 left-40"
                  width={22}
                  height={20}
                  quality={100}
                />
              </p>
              <div className="flex justify-start gap-2 mt-6 font-medium text-[#202852] text-[20px] leading-6">
                <span className="text-[#3174d6] font-bold">Accounting</span> |{" "}
                <span className="text-[#008D82] font-bold">Healthcare</span> |{" "}
                <span className="text-[#CA7216] font-bold">Business</span>
              </div>
            </div>
          </div>
        </div>
        <div className="lg_desktop">
          <Image
            src="/hire-from-miles/hfm-desk-ban.png"
            alt="Hire From Miles"
            className="absolute -top-[40px] bottom-0 right-0 xl:w-[1070px] lg:w-[1040px]"
            width={1083}
            height={1564}
            priority
          />
        </div>
      </div>
      <div className="md_desktop">
        <Image
          src="/hire-from-miles/hfm-desk-ban.png"
          alt="Hire From Miles"
          className="absolute -top-10 right-0 md:block hidden xl:w-[1100px] lg:w-[840px]"
          width={1083}
          height={1564}
          priority
        />
      </div>
    </div>
  );
};

export default BannerDesktopHFM;
